module.exports = __webpack_public_path__ + "media/images/emblems/Kirchdorf-coat_of_arms-afa335b679137325d6a77c7eee6c9fdd.svg";